function isAmbiguous ({result}) {
	return result.length > 1;
}

module.exports = isAmbiguous;